import clsx from 'clsx';
import PropTypes from 'prop-types';

function GlassCard({ children, className = '' }) {
  const baseClass = `
    bg-[rgba(255,_255,_255,_0.05)] backdrop-filter backdrop-blur-[5px] rounded-[20px] border-[1px] border-[solid] border-[rgba(255,255,255,0.3)] [box-shadow:0_8px_32px_rgba(0,_0,_0,_0.1),_inset_0_1px_0_rgba(255,_255,_255,_0.5),_inset_0_-1px_0_rgba(255,_255,_255,_0.1),_inset_0_0_0px_0px_rgba(255,_255,_255,_0)] relative overflow-hidden
            
    before:content-[''] before:absolute before:top-[0] before:left-[0] before:right-[0] before:h-px before:bg-[linear-gradient(_90deg,_transparent,_rgba(255,_255,_255,_0.8),_transparent_)]
    
    after:content-[''] after:absolute after:top-[0] after:left-[0] after:w-px after:h-full after:bg-[linear-gradient(_180deg,_rgba(255,_255,_255,_0.8),_transparent,_rgba(255,_255,_255,_0.3)_)]
  `;

  return <div className={clsx(baseClass, className)}>{children}</div>;
}

GlassCard.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default GlassCard;
